import { render } from "./OcrReportColumnMap.vue?vue&type=template&id=01754aa1"
import script from "./OcrReportColumnMap.vue?vue&type=script&lang=js"
export * from "./OcrReportColumnMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__